import React from "react";
import {Link} from "gatsby";
import {MinusSmallIcon} from '@heroicons/react/24/solid'

type Props = {
    title: string
    link: string
    isBold?: boolean
}

export const NavLink: React.FunctionComponent<Props> = ({title, link, isBold}) => {

    return (
        <div className={'p-2 ' + (isBold ? "font-medium bg-primary-100 rounded" : "")}>
            <Link to={link} className="text-ellipsis overflow-hidden">
                <MinusSmallIcon width="1rem" height="1rem" className="inline-block"/>&ensp;{title}
            </Link>
        </div>)
}